import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import enTranslation from './locales/en.json';
import svTranslation from './locales/sv.json';

const resources = {
    en: {
        translation: enTranslation,
    },
    sv: {
        translation: svTranslation,
    },
};

i18n.use(initReactI18next)
    .use(HttpApi)
    .init({
        resources,
        lng: 'sv',
        fallbackLng: 'en',
        backend: {
            loadPath: './locales/{{lng}}.json', // Filplats för översättningar
        },
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
